import styled from "styled-components";

export const SignUpContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 25rem;
    @media screen and (max-width: 792px) {
        width: fit-content;
       }
`

export const H2Font = styled.h2`
    margin: 10px 0;
`


